import { request } from "../";
export function createBranchPlan(data) {
  return request({ url: "branch-plans/", method: "POST", data });
}
export function getPlans() {
  return request({ url: "plans/" });
}
export function getBranchPlan() {
  return request({ url: "branch-plans/" });
}
export function getBranchInvoices() {
  return request({ url: "invoices/" });
}
export function getNotesPack() {
  return request({ url: "plans/notes-packs/" });
}
export function selectNotesPacks(pack, branchOwnerId = null) {
  if (branchOwnerId) {
    return request(
      { url: "plans/select-notes-packs/", method: "POST", data: pack },
      true,
      branchOwnerId
    );
  }
  return request({
    url: "plans/select-notes-packs/",
    method: "POST",
    data: pack,
  });
}
export function upgradeBranchPlan({ plan, new_plan_id, payable_with, period } = {}) {
  const data = {
    new_plan_id: new_plan_id || plan,
    payable_with,
    period,
  };
  return request({ url: "branch-plans/upgrade/", method: "PUT", data });
}
export function adjustPlan() {
  return request({ url: "branch-plans/adjust/", method: "PUT" });
}
export function unSubscribe(data) {
  return request({ url: "feedbacks/cancel-plan/", method: "POST", data });
}
export function getIugu(id) {
  return request({ url: `invoices/${id}/iugu/` });
}

/**
 * Envia o token seguro gerado pela Iugu (diretamente no navegador) para o backend.
 * O número e CVV do cartão NUNCA passam pelo nosso servidor — apenas este token.
 */
export function updateCreditCard({ token, description }) {
  return request({
    url: "branch-plans/update-credit-card/",
    method: "POST",
    data: { token, description },
  });
}

/**
 * Busca o account_id público da Iugu do backend.
 * O backend o obtém dinamicamente via /v1/profile — sem nenhuma var de ambiente nova.
 */
export function getIuguConfig() {
  return request({ url: 'branch-plans/iugu-config/' });
}




// WEBPACK FOOTER //
// ./src/api/plans/index.js